import { isInWhiteHosts } from "./whiteHosts";
import { getXToken } from "@/utils/chat/index";
import { getAuthInfo } from "@/utils";

export const addXtoken = (url: string, xToken?: string) => {
  let newUrl = url;
  if (isInWhiteHosts(url) && !url.includes("x-token")) {
    const token = xToken || getXToken();
    const [partI, partII] = url.split("?");
    console.log("newUrl1", newUrl, xToken, getXToken(), token);
    newUrl = `${partI}${partII ? "?" + partII + "&" : "?"}x-token=${token}`;
  }
  console.log("newUrl2", newUrl);
  return newUrl;
};

export const addXclient = async (url: string) => {
  const authInfo = await getAuthInfo();
  let newUrl = url;
  if (isInWhiteHosts(url) && !url.includes("x-client")) {
    const client = authInfo["x-client"];
    const [partI, partII] = url.split("?");
    newUrl = `${partI}${partII ? "?" + partII + "&" : "?"}x-client=${client}`;
  }
  return newUrl;
};
